<template>
<div class="container">
    <div class="goBackBtn" @click="$router.go(-1)">
      <h2>
        X
      </h2>
    </div>
    <div id="terms" class="terms-conditions" v-html="tycos"></div>
  </div>
  <!-- <div class="modal-body terms-conditions">
    <div v-html="tycos"></div>
    <div v-html="campaign"></div>
  </div> -->
</template>

<script>
import Axios from 'axios'
import { mapActions } from "vuex";
export default {
  name: "Terms",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
  data(){
    return {
      tycos:'',
      //campaign:'',
    }
  },
  async mounted(){
    window.scrollTo(0,0)
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/tycos?type=1', { headers :{
        campaign: 'general'
        }})
    this.tycos = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";
        }`,'').replace("[[urlsitio]]", "https://strongbow.mx/")
    
    // let campaignResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/tycos?type=2', {headers:{
    //     campaign: 'strongbow'
    //   }})
    // this.campaign = campaignResponse.data.replace('{', '').replace('"body":"', '').replace(`";
    //     }`,'')
  },
  async beforeRouteLeave() {
    this.setAgeGateTokenAction(false)
    location.reload()
  },
  methods: {
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
  }
};
</script>
<style lang="scss" >
@import "~@/styles/variables.scss";
.container {
  padding-top: 0vw;
  @media screen and (max-width: 768px) {
    padding-top: 13vw;
  }
}
.goBackBtn {
  display: flex;
  flex-direction: row;
  width: 80px;
  background-color: transparent;
  border: none;
  color: $black;
  font-family: $font-Dunbar-Light;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  h2 {
    color: $black !important;
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}
.terms-conditions {
  padding-inline: 2vw;
  font-family: 'DunbarTall-Light' !important;
  font-size: 1.7vw !important;
  margin-right: 4.2pt !important;
  margin-left: 0pt !important;
  color: $black !important;
  margin-top: 7vw !important;
  text-align: justify;
  text-transform: uppercase !important;
  h2 {
    margin-bottom: 2vw !important;
  }
  h3, p{
    margin: 0;
    margin-bottom: 0rem;
    font-family: 'DunbarTall-Light' !important;
  }
  *{
    font-family: 'DunbarTall-Light' !important;
    font-size: 1rem !important;
    letter-spacing: 0.1vw !important;
  }
}
</style>
